import { render, staticRenderFns } from "./popper-container.vue?vue&type=template&id=65c6ba22&scoped=true&"
import script from "./popper-container.vue?vue&type=script&lang=js&"
export * from "./popper-container.vue?vue&type=script&lang=js&"
import style0 from "./popper-container.vue?vue&type=style&index=0&id=65c6ba22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c6ba22",
  null
  
)

export default component.exports